import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormFieldModule } from '../form-field/form-field.module';
import { SelectComponent } from './components/select/select.component';

@NgModule({
  imports: [FormFieldModule, ReactiveFormsModule, FormsModule, NgSelectModule],
  declarations: [SelectComponent],
  exports: [FormFieldModule, NgSelectModule],
})
export class SelectModule {}
